export enum PiAiEnum {
    PI = 'PI',
    AI = 'AI',
}
